import { render, staticRenderFns } from "./PotensiDetail.vue?vue&type=template&id=e63dda26&scoped=true"
import script from "./PotensiDetail.vue?vue&type=script&lang=js"
export * from "./PotensiDetail.vue?vue&type=script&lang=js"
import style0 from "./PotensiDetail.vue?vue&type=style&index=0&id=e63dda26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e63dda26",
  null
  
)

export default component.exports